import dynamic from "next/dynamic"
import { useMemo } from "react"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { ListProps } from '@mui/material/List';
import { capitalize } from '@mui/material/utils';
import Link from "next/link"
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useRouter } from "next/router"
import FindFilterMobileListItem from "../FindFilterMobileListItem"
import { filterUrl } from "../Find"
import { FindFilterCategoryListItemProps } from "../FindDesignTypes"
import { PageType } from "../../../../pages/_app"
import { FilterBaseProps } from "../Find.types"

const FilterCategory = ({
  filters,
  colors,
  pageUrl,
  mmbr,
  isMobile,
  closeSubmenu
}: FilterBaseProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindFilterCategoryList = useMemo(() => dynamic<ListProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindFilterCategoryList)), [path])
  const FindFilterCategoryListItem = useMemo(() => dynamic<FindFilterCategoryListItemProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindFilterCategoryListItem)), [path])
  
  const allCategories = filters?.items?.some((item) => item.selected) ? false : true

  return (
    <>
      {isMobile ? (
        <>
          {filters?.items?.map((item, i) => (
              <FindFilterMobileListItem
                key={i}
                filters={filters}
                item={item}
                multiSelect={false}
                colors={colors}
                pageUrl={pageUrl}
                mmbr={mmbr}
                closeSubmenu={closeSubmenu}
              />
            )
          )}
        </>
      ) : (
        <FindFilterCategoryList>
          <FindFilterCategoryListItem disablePadding color={colors.mainColor}>
            <Link href={filterUrl(filters, undefined, filters.resetUrl, pageUrl, mmbr) ?? router.asPath} scroll={false} passHref>
              <a className={allCategories ? 'selected' : undefined}>
                <DoubleArrowIcon /> Összes kategória
              </a>
            </Link>
          </FindFilterCategoryListItem>
          <FindFilterCategoryListItem subitem={1}>
            <FindFilterCategoryList disablePadding>
              {filters?.items?.map((item, i) => (
                <FindFilterCategoryListItem
                  key={i}
                  disablePadding
                  color={colors.mainColor}
                >
                  <Link href={filterUrl(filters, item, undefined, pageUrl, mmbr) ?? router.asPath} scroll={false} passHref>
                    <a className={item.selected ? 'selected' : undefined}>
                      <DoubleArrowIcon /> {capitalize(item.title as string)} <span>({item.count})</span>
                    </a>
                  </Link>
                </FindFilterCategoryListItem>
              ))}
            </FindFilterCategoryList>
          </FindFilterCategoryListItem>
        </FindFilterCategoryList>
      )}
    </>
  )
}

export default FilterCategory